<template>
  <NotificationTemplate :notification="notification">
    <template #pic>
      <div class="label-pic is-purple">
        <icon
          data="@icon/task-icon.svg"
          class="label-pic__icon"
          :fill="true"
          width="var(--icon-24)"
          height="var(--icon-24)"
          color="#6A1B9A"
        />
      </div>
    </template>
    <template #title>
      <BaseSubHeading
        size="large"
        color="monochrome-06"
        darkColor="monochrome-03"
        weight="400"
      >
        <a
          class="link is-large"
          target="_blank"
          :href="notification.content?.itemUrl ?? '#'"
        >
          Item #{{ notification.content?.sequenceNumber ?? $t("none") }}
        </a>
        <span
          v-if="initiatorFullName"
          class="notification__update-item__initiator"
        >
          @{{ initiatorFullName }}</span
        >
        assigned you the Owner of the following Tasks
      </BaseSubHeading>
    </template>
    <template #content>
      <div
        v-for="(task, key) in notification.content?.tasks"
        :key="key"
        className="notification__update-time-left__task"
      >
        <BaseSubHeading
          size="medium"
          color="markingOrange-02"
          weight="500"
          className="notification__update-time-left__task__status"
        >
          New
        </BaseSubHeading>
        <BaseSubHeading
          size="medium"
          color="monochrome-07"
          weight="400"
          className="notification__update-time-left__task__name"
        >
          {{ task.name }}
        </BaseSubHeading>
        <BaseSubHeading
          size="medium"
          color="monochrome-06"
          darkColor="monochrome-03"
          weight="500"
          className="notification__update-time-left__task__type"
        >
          {{ $t(`cycleTimeByTaskType.${task.type}`) }}
        </BaseSubHeading>

        <BaseSubHeading
          size="small"
          color="monochrome-07"
          weight="500"
          className="notification__update-time-left__task__estimation is-grey"
        >
          -
        </BaseSubHeading>
      </div>
    </template>
  </NotificationTemplate>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component"
import { Prop } from "vue-property-decorator"

import NotificationTemplate from "@/components/Notification/NotificationTemplate.vue"

import { NotificationItem } from "@/models/Notification/NotificationItem"

@Options({
  name: "TASK_OWNER_ASSIGMENT_NOTIFICATION",
  components: {
    NotificationTemplate
  }
})
export default class TASK_OWNER_ASSIGMENT_NOTIFICATION extends Vue {
  @Prop() readonly notification: NotificationItem

  get initiatorFullName() {
    if (!this.notification.content.initiators) return ""

    const { firstName, lastName } = this.notification.content.initiators[0]
    return `${firstName} ${lastName}`
  }
}
</script>
